class AjaxReloader {
	initiates() {
		this.#discoverLinks(document);
	}

	#discoverLinks(base) {
		let ajaxLinks = base.querySelectorAll('[data-ajax]');
		ajaxLinks.forEach((link) => this.#linkActionHandler(link));
	}

	#linkActionHandler(element) {
		if (element.nodeName === "A" || element.nodeName === "BUTTON") {
			element.addEventListener(
				'click',
				(event) => {
					event.preventDefault();
					this.#performAjaxRequest(element);
				});
		} else if (element.nodeName === "OPTION") {
			if (!element.parentNode.hasAttribute("data-ajax-marked")) {
				element.parentNode.setAttribute("data-ajax-marked", "true");
				element.parentNode.addEventListener(
					'change',
					(event) => {
						this.#performAjaxRequest(element.parentNode.options[element.parentNode.selectedIndex]);
					});
			}
		}
	}

	#performAjaxRequest(triggerElement) {
		let hrefData = "";
		if (triggerElement.hasAttribute('href')) {
			hrefData = triggerElement.getAttribute('href');
		} else if (triggerElement.hasAttribute('data-href')) {
			hrefData = triggerElement.dataset.href;
		}
		const ajaxLink = location.protocol + '//' + location.host + location.pathname + hrefData;
		const xhr = new XMLHttpRequest();
		const parser = new DOMParser();
		xhr.open("GET", ajaxLink);
		xhr.send();
		xhr.addEventListener("load", (event) => {
			if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
				const htmlUpdatedPage = parser.parseFromString(xhr.responseText, 'text/html');
				this.#discoverLinks(htmlUpdatedPage);
				let currentElement = document.querySelector(triggerElement.dataset.ajaxRefreshSelector);
				currentElement.parentNode.replaceChild(
					htmlUpdatedPage.querySelector(triggerElement.dataset.ajaxRefreshSelector),
					currentElement
				);
				history.pushState({}, "", ajaxLink);
			} else {
				window.location = ajaxLink;
				// console.log("redirect on error");
			}
		});
	}
}

export default new AjaxReloader();
